// src/shared/api/instance.ts
import createFetchClient from "openapi-fetch";
import createClient from "openapi-react-query"; // generated by openapi-typescript
// import { publicConfig } from "@/shared/config/public";
// import { ApiPaths } from "./schema";
// import { useSession } from "../model/session";
import { useAppState } from "../../state";
import { getAccessToken } from "../../state/useAuth/useAuth";

export const fetchClient = createFetchClient({
  baseUrl: process.env.REACT_APP_API_BASE_URL, //publicConfig.API_BASE_URL,
});

export const rqClient = createClient(fetchClient);

export const publicFetchClient = createFetchClient({
  baseUrl: process.env.REACT_APP_API_BASE_URL, //publicConfig.API_BASE_URL,
});
export const publicRqClient = createClient(publicFetchClient);

// const token = getAccessToken();

fetchClient.use({
  async onRequest({ request }) {
    // const { signOut } = useAppState();
    // why we was getting token outside?
    const token = getAccessToken(); //await useSession.getState().refreshAccessToken();

    if (token) {
      request.headers.set("Authorization", `Bearer ${token}`);
    } else {
      // signOut();
      // useSession.getState().logout();
      return new Response(
        JSON.stringify({ success: false, code: "UNAUTHORIZED" }),
        { status: 401 }
      );
    }
  },
  async onResponse({ response }) {
    // const { signOut } = useAppState();
    if (response.status === 401 || response.status === 403) {
      // signOut();
      //useSession.getState().logout();
      // if (typeof window !== "undefined") {
      //   window.location.href = "/admin/login";
      // }
    }
  },
});
